import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="footer-background">
        <div className="footer-gradient"></div>
      </div>
      <div className="container">
        <div className="footer-content">
          <div className="footer-grid">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <ul className="footer-links">
                <li><a href="#home">Home</a></li>
                <p>Hopmate is a platform that allows you to connect with a therapist online. It is a great way to get help with your mental health.</p>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-title">Support</h3>
              <ul className="footer-links">
                <li><a href="https://help.hopmate.in/privacy" target="_blank" rel="noopener noreferrer">Privacy</a></li>
                <li><a href="https://help.hopmate.in/support" target="_blank" rel="noopener noreferrer">Support</a></li>
                <li><a href="https://help.hopmate.in/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
                <li><a href="https://help.hopmate.in/return" target="_blank" rel="noopener noreferrer">Return</a></li>
              </ul>
            </div>

            <div className="footer-column footer-download">
              <h3 className="footer-title">Download Hopmate Now</h3>
              <div className="download-buttons">
                <a 
                  href="http://play.google.com/store/apps/details?id=com.simpleviralgames.hopmate"
                  className="download-button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg className="download-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L14.54,17.15L16.81,19.42L20.16,16.19C20.66,15.85 21,15.23 21,14.5V9.5C21,8.77 20.66,8.15 20.16,7.81L16.81,4.58L14.54,6.85L20.16,10.81Z"/>
                  </svg>
                  <div className="download-text">
                    <span className="download-label">GET IT ON</span>
                    <span className="download-platform">Play Store</span>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>Made with ❤️ in India</p>
              <p>RAHSOU SIMPLE VIRAL GAMES PRIVATE LIMITED</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

